<template>
  <el-table-column
    prop="social_insurance_number"
    label="TB szám"
    sortable="custom"
    min-width="150"
    show-overflow-tooltip
  >
    <template slot-scope="scope">
      {{ scope.row.social_insurance_number || '-' }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'social_insurance_number',
  };
</script>
